import React from 'react';
import PropTypes from 'prop-types';

const ExpandIcon = ({ className }) => {
    return (
        <svg
        className={className}
        width="24"
        height="24"
        viewBox="0 0 24 24" 
        fill="none" 
        xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_173_9218)">
                <path d="M22.6516 1.11691C21.9433 0.408627 20.9898 0 19.9274 0H16.2498V1.47106H19.9002C20.554 1.47106 21.1533 1.74347 21.5891 2.17934C22.025 2.61521 22.2974 3.21453 22.2974 3.86833V7.76391H23.7685V3.84109C23.7685 2.77866 23.3326 1.8252 22.6516 1.11691Z" fill="white" />
                <path d="M2.41091 21.7934C1.97504 21.3575 1.70262 20.7582 1.70262 20.1044V16.2361H0.231567V20.1317C0.231567 21.1941 0.667436 22.1475 1.34848 22.8558C2.08401 23.5369 3.03747 23.9727 4.0999 23.9727H7.7503V22.5017H4.0999C3.4461 22.5017 2.84678 22.2293 2.41091 21.7934Z" fill="white" />
                <path d="M22.2702 20.1317C22.2702 20.7855 21.9978 21.3848 21.5619 21.8206C21.126 22.2565 20.5267 22.5289 19.8729 22.5289H16.2498V24H19.9002C20.9626 24 21.916 23.5641 22.6243 22.8831C23.3326 22.1748 23.7412 21.2213 23.7412 20.1589V16.2361H22.2702V20.1317Z" fill="white" />
                <path d="M1.3757 1.11691C0.667416 1.8252 0.258789 2.77866 0.258789 3.84109V7.73666H1.72984V3.84109C1.72984 3.18729 2.00226 2.58797 2.43813 2.1521C2.874 1.71623 3.47332 1.44381 4.12712 1.44381H7.77752V0H4.09988C3.03745 0 2.08399 0.435868 1.3757 1.11691Z" fill="white" />
            </g>
            <defs>
                <clipPath id="clip0_173_9218">
                    <rect width="24" height="24" fill="white" />
                </clipPath>
            </defs>
        </svg>

    );
};

ExpandIcon.propTypes = {
    className: PropTypes.string, // Optional: allows passing Tailwind or custom classes
};

ExpandIcon.defaultProps = {
    className: '', // Default to an empty string
};

export default ExpandIcon;